export default __webpack_public_path__ + "static/media/home-startup-slider-bg-01.aae3e275.jpg";